import React from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";
import { useModal } from "./useModal";

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
  variant?: "bottom" | "center";
  closeOnBackdrop?: boolean;
  closeOnEsc?: boolean;
  children: React.ReactNode;
}

export default function Modal({
  isVisible,
  onClose,
  variant = "bottom",
  closeOnBackdrop = true,
  closeOnEsc = true,
  children,
}: ModalProps) {
  const { handleBackdropClick } = useModal(isVisible, onClose, {
    closeOnBackdrop,
    closeOnEsc,
  });

  if (!isVisible) return null;

  return createPortal(
    <div
      className={`${styles.overlay} ${styles[`overlay_${variant}`]}`}
      onClick={handleBackdropClick}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>,
    document.body,
  );
}
